module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-public-entry"
  }, [_c('div', {
    staticClass: "aso-public-entry__body"
  }, [_c('div', {
    staticClass: "aso-public-entry__card"
  }, [_c('h1', [_vm._v("Assinatura de ASO")]), _vm._v(" "), _c('p', {
    staticClass: "aso-public-entry__context"
  }, [_c('strong', [_vm._v(_vm._s(_vm.tenantTitleCase))]), _vm._v("\n      | Consulta\n      "), _c('strong', [_vm._v(_vm._s(_vm.idConsulta))])]), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "aso-public-entry__status"
  }, [_vm._v("\n      Consultando status da assinatura...\n    ")]) : (_vm.errorMessage) ? _c('div', {
    staticClass: "aso-public-entry__status aso-public-entry__status--error"
  }, [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]) : (_vm.alreadySigned) ? _c('div', {
    staticClass: "aso-public-entry__signed-card"
  }, [_c('svg', {
    staticClass: "aso-public-entry__signed-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 6.41-6.29 6.3a1 1 0 0 1-1.42 0L7 12.41a1 1 0 1 1 1.41-1.41L10 12.59l5.59-5.59A1 1 0 0 1 17 8.41z",
      "fill": "#127902"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "aso-public-entry__signed-title"
  }, [_vm._v(_vm._s(_vm.justSigned ? 'ASO assinado com sucesso!' : 'O ASO referente a esta consulta já está assinado!'))])]) : _c('div', {
    staticClass: "aso-public-entry__status aso-public-entry__status--pending"
  }, [_c('p', {
    staticClass: "aso-public-entry__subtitle"
  }, [_vm._v("\n        Documento ainda não assinado. Siga as etapas para finalizar o processo.\n      ")]), _vm._v(" "), (_vm.showValidationBoard) ? _c('section', {
    staticClass: "aso-public-entry__validation-board",
    attrs: {
      "aria-label": "Validação de Informações"
    }
  }, [_c('h2', {
    staticClass: "aso-public-entry__validation-title"
  }, [_vm._v("Validação de Informações")]), _vm._v(" "), _c('p', {
    staticClass: "aso-public-entry__validation-subtitle"
  }, [_vm._v("\n          Valide as informações necessárias para finalizar o cadastro\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__validation-list"
  }, [_c('article', {
    staticClass: "aso-public-entry__validation-item",
    class: _vm.validationClass('email')
  }, [_c('div', {
    staticClass: "aso-public-entry__validation-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('email-icon')], 1), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__validation-copy"
  }, [_c('h3', [_vm._v("Validação de e-mail")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.emailStatusLabel))])]), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__validation-action aso-flow-button aso-flow-button--loud aso-flow-button--compact",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.isValidationActionVisible('email')
    },
    on: {
      "click": function($event) {
        return _vm.goToValidationStep('email')
      }
    }
  }, [_vm._v("\n              Validar\n            ")])]), _vm._v(" "), _c('article', {
    staticClass: "aso-public-entry__validation-item",
    class: _vm.validationClass('identidade')
  }, [_c('div', {
    staticClass: "aso-public-entry__validation-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('id-icon')], 1), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__validation-copy"
  }, [_c('h3', [_vm._v("Validação de identidade")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.identidadeStatusLabel))])]), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__validation-action aso-flow-button aso-flow-button--loud aso-flow-button--compact",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.isValidationActionVisible('identidade')
    },
    on: {
      "click": function($event) {
        return _vm.goToValidationStep('identidade')
      }
    }
  }, [_vm._v("\n              Validar\n            ")])]), _vm._v(" "), (!_vm.cadastroExistente) ? _c('article', {
    staticClass: "aso-public-entry__validation-item",
    class: _vm.validationClass('telefone')
  }, [_c('div', {
    staticClass: "aso-public-entry__validation-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('phone-icon')], 1), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__validation-copy"
  }, [_c('h3', [_vm._v("Validação de telefone")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.telefoneStatusLabel))])]), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__validation-action aso-flow-button aso-flow-button--loud aso-flow-button--compact",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.isValidationActionVisible('telefone')
    },
    on: {
      "click": function($event) {
        return _vm.goToValidationStep('telefone')
      }
    }
  }, [_vm._v("\n              Validar\n            ")])]) : _vm._e(), _vm._v(" "), (!_vm.cadastroExistente) ? _c('article', {
    staticClass: "aso-public-entry__validation-item",
    class: _vm.validationClass('senha')
  }, [_c('div', {
    staticClass: "aso-public-entry__validation-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('password-icon')], 1), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__validation-copy"
  }, [_c('h3', [_vm._v("Validação de senha")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.senhaStatusLabel))])]), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__validation-action aso-flow-button aso-flow-button--loud aso-flow-button--compact",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.isValidationActionVisible('senha')
    },
    on: {
      "click": function($event) {
        return _vm.goToValidationStep('senha')
      }
    }
  }, [_vm._v("\n              Validar\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__validation-footer"
  }, [_c('button', {
    staticClass: "aso-public-entry__validation-secondary aso-flow-button aso-flow-button--quiet aso-flow-button--compact",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.resetValidationBoard
    }
  }, [_vm._v("\n            Limpar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__validation-primary aso-flow-button aso-flow-button--loud aso-flow-button--compact",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canAdvanceValidationBoard
    },
    on: {
      "click": _vm.advanceValidationBoard
    }
  }, [_vm._v("\n            Finalizar\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.stepMessage) ? _c('p', {
    class: ['aso-public-entry__hint', _vm.stepError ? 'aso-public-entry__hint--error' : 'aso-public-entry__hint--ok']
  }, [_vm._v("\n        " + _vm._s(_vm.stepMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.wizardComplete) ? _c('div', {
    staticClass: "aso-public-entry__status aso-public-entry__status--ok aso-public-entry__status--compact"
  }, [_vm._v("\n        Processo concluído com sucesso. Recarregando status da assinatura...\n      ")]) : (!_vm.showValidationBoard) ? _c('div', [(_vm.currentStep === 1) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [(_vm.emailValidationView === 'email') ? _c('aso-validar-email-step', {
    attrs: {
      "email": _vm.email,
      "busy": _vm.busy
    },
    on: {
      "update:email": function($event) {
        _vm.email = $event
      },
      "continue": _vm.enviarTokenEmail
    }
  }) : _c('aso-valida-token-email-step', {
    attrs: {
      "email": _vm.email,
      "values": _vm.emailTokenValues,
      "busy": _vm.busy,
      "can-resend": _vm.tokenExpired,
      "resend-label": _vm.tokenResendLabel
    },
    on: {
      "digit-input": _vm.onEmailTokenDigitInput,
      "digit-keydown": _vm.onEmailTokenDigitKeydown,
      "paste": _vm.onEmailTokenPaste,
      "change-email": _vm.goToEmailForm,
      "confirm": _vm.validarToken,
      "resend": _vm.reenviarTokenEmail
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentStep === 2) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [_c('h2', [_vm._v("2. Validação de identidade")]), _vm._v(" "), _c('aso-validar-identidade-step', {
    attrs: {
      "cpf": _vm.cpf,
      "busy": _vm.busy,
      "cadastro-existente": _vm.cadastroExistente,
      "editavel": _vm.cadastroEditavel,
      "nome": _vm.nome,
      "masked-nome": _vm.cadastroMaskedNome,
      "masked-cpf": _vm.cadastroMaskedCpf,
      "sexo": _vm.sexo,
      "data-nascimento": _vm.dataNascimento
    },
    on: {
      "update:cpf": function($event) {
        _vm.cpf = $event
      },
      "update:nome": function($event) {
        _vm.nome = $event
      },
      "update:sexo": function($event) {
        _vm.sexo = $event
      },
      "update:dataNascimento": function($event) {
        _vm.dataNascimento = $event
      },
      "toggle-edit": function($event) {
        _vm.cadastroEditavel = $event;
        _vm.onCadastroEditavelToggle()
      },
      "validate": function($event) {
        _vm.cadastroExistente ? _vm.confirmarDadosExistente() : _vm.validarCpf()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentStep === 3) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [_c('h2', [_vm._v("3. Validação de telefone")]), _vm._v(" "), (_vm.phoneValidationView === 'phone') ? _c('aso-validar-telefone-step', {
    attrs: {
      "telefone": _vm.telefone,
      "busy": _vm.busy
    },
    on: {
      "update:telefone": function($event) {
        _vm.telefone = $event
      },
      "continue": _vm.enviarTokenTelefone
    }
  }) : _c('aso-valida-token-telefone-step', {
    attrs: {
      "telefone": _vm.telefone,
      "values": _vm.phoneTokenValues,
      "busy": _vm.busy,
      "can-resend": _vm.tokenExpired,
      "resend-label": _vm.tokenResendLabel
    },
    on: {
      "digit-input": _vm.onPhoneTokenDigitInput,
      "digit-keydown": _vm.onPhoneTokenDigitKeydown,
      "paste": _vm.onPhoneTokenPaste,
      "confirm": _vm.validarTokenTelefone,
      "resend": _vm.reenviarTokenTelefone
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentStep === 4) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [_c('h2', [_vm._v("4. Validação de senha")]), _vm._v(" "), _c('aso-validar-senha-step', {
    attrs: {
      "password": _vm.password,
      "password-confirm": _vm.passwordConfirm,
      "password-error": _vm.passwordConfirmError,
      "busy": _vm.busy
    },
    on: {
      "update:password": function($event) {
        _vm.password = $event
      },
      "update:passwordConfirm": function($event) {
        _vm.passwordConfirm = $event
      },
      "confirm-blur": _vm.onPasswordConfirmBlur,
      "continue": _vm.validarSenha
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentStep === 5) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [_c('h2', [_vm._v("5. Upload dos documentos")]), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__form"
  }, [_c('upload-document-card', {
    attrs: {
      "side": "frente",
      "label": "Frente",
      "busy": _vm.busy,
      "loading": _vm.uploadLoadingFrente,
      "has-error": _vm.uploadErrorFrente,
      "uploaded": !!_vm.frenteDocumento,
      "disabled": false
    },
    on: {
      "selected": _vm.onDocumentSelected
    }
  }), _vm._v(" "), _c('upload-document-card', {
    attrs: {
      "side": "verso",
      "label": "Verso",
      "busy": _vm.busy,
      "loading": _vm.uploadLoadingVerso,
      "has-error": _vm.uploadErrorVerso,
      "uploaded": !!_vm.versoDocumento,
      "disabled": !_vm.frenteDocumento
    },
    on: {
      "selected": _vm.onDocumentSelected
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__button aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canSaveDocumentos
    },
    on: {
      "click": _vm.salvarDocumentos
    }
  }, [_vm._v("\n              " + _vm._s(_vm.busy ? 'Enviando...' : 'Salvar documentos') + "\n            ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 6) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [_c('h2', [_vm._v("6. Assinatura")]), _vm._v(" "), _c('p', {
    staticClass: "aso-public-entry__hint"
  }, [_vm._v("\n            Envie uma foto nítida do seu rosto para concluir a assinatura do ASO.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__form"
  }, [_c('upload-face-card', {
    attrs: {
      "busy": _vm.busy,
      "loading": _vm.uploadLoadingRosto,
      "has-error": _vm.uploadErrorRosto,
      "uploaded": !!_vm.fotoRosto,
      "disabled": false
    },
    on: {
      "selected": _vm.onSelectFace
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__button aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.salvarAssinatura
    }
  }, [_vm._v("\n              " + _vm._s(_vm.busy ? 'Finalizando...' : 'Concluir assinatura') + "\n            ")])], 1)]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29ee98e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/funcionario/aso/assinar/index.vue
// module id = 1435
// module chunks = 45